export default function ErrorToaster({ error }) {
  return console.log(
    error?.response?.data?.message
      ? error?.response?.data?.message
      : error?.message
  );
}
